import { doAuthenticateOnServer } from 'actions/auth'
import { doAcceptInvitation, doGetUserByInvitation } from 'actions/invitations'
import { selectInvitationToken } from './selectors'

export function doAcceptUserInvitation(params) {
  return (dispatch, getState) => {
    const state = getState()
    const invitationToken = selectInvitationToken(state)
    const acceptInvitationInput = {
      invitationToken,
      name: params.firstLastNameInput,
      username: params.usernameInput,
      password: params.passwordInput,
    }

    return doAcceptInvitation(acceptInvitationInput)(dispatch, getState).then(
      user =>
        doAuthenticateOnServer(
          user.email,
          params.passwordInput,
          user.subdomain
        )(dispatch, getState)
    )
  }
}

export function doGetUserByInvitationOrRedirect() {
  return (dispatch, getState) => {
    const state = getState()
    const invitationToken = selectInvitationToken(state)
    // If the invitation doesnt exists, it'll throw an error
    // which means we should then redirect to the login page
    return doGetUserByInvitation(invitationToken)(dispatch, getState).catch(
      () => {
        // Suppress error as reducer is taking care of it
      }
    )
  }
}
